import { animate, query, state, style, transition, trigger } from '@angular/animations';
import { Component, OnInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { ThemePalette } from '@angular/material/core';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { InfosUser } from 'app/shared/models/class/auth/infosUser';
import { BookedSessionByBookingKey, BookingUser } from 'app/shared/models/class/booking-session/booking-session';
import { AuthService } from 'app/shared/services/auth/auth.service';
import { BookingSessionService } from 'app/shared/services/booking-session/booking-session.service';
import { FaiconService } from 'app/shared/services/faicon/faicon.service';
import { PdfService } from 'app/shared/services/pdf/pdf.service';
import { TooltipService } from 'app/shared/services/tooltip/tooltip.service';

@Component({
  selector: 'app-session-booked-history',
  templateUrl: './session-booked-history.component.html',
  styleUrls: ['./session-booked-history.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
    trigger('view', [
      transition(':enter', [
        query('.wrap', [
          style({ opacity: 0, transform: 'translate(-200px)' }),
          animate('.17s', style({ opacity: 1, transform: 'none' })),
        ], { optional: true })
      ]),
    ]),
    trigger('update', [
      transition(':enter', [
        query('.wrap', [
          style({ opacity: 0, transform: 'translate(200px)' }),
          animate('.17s', style({ opacity: 1, transform: 'none' })),
        ], { optional: true })
      ]),
    ])
  ],
})

export class SessionBookedHistoryComponent implements OnInit {

  searchForm: UntypedFormGroup;
  valueInput = '';
  selectBookingMobileForm: UntypedFormGroup;
  selectSessionForm: UntypedFormGroup;

  displayedColumns: string[] = [];
  dataSource: MatTableDataSource<BookingUser>;
  expandedElement: any | null;

  offerPreview: BookedSessionByBookingKey;

  @ViewChild(MatSort, { static: false }) sort: MatSort;
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;

  length: number;
  pageSize = 5;
  pageSizeOptions: number[] = [5, 10, 25, 50];
  pageEvent: PageEvent;

  color: ThemePalette = 'primary';

  bookedSessionsGroup = [];

  bookedOffersFilteredForMobile: any[];
  userKey: any;
  booking: BookingUser[];
  tab = 'overview';
  tabsColum = 2;
  sessions: BookedSessionByBookingKey[] = [];
  bookingFiltered: BookingUser[] = [];
  checkRoute!: number;
  title!: string;
  userConnected: InfosUser;
  isDownloading = false;


  constructor(
    private formBuilder: UntypedFormBuilder,
    private bookingSessionService: BookingSessionService,
    private authService: AuthService,
    private router: Router,
    private route: ActivatedRoute,
    private pdfService: PdfService,
    private tooltip: TooltipService,
    private faIconService: FaiconService,
  ) {
  }

  ngOnInit(): void {
    this.initComponent();
    this.initForm();
  }

  getFaIcon(faIcon: string): string {
    return this.faIconService.getFaIcon(faIcon);
  }

  applyFilter(filterValue): void {
    this.valueInput = filterValue;
    const keyWord = filterValue.trim().toLowerCase();
    this.dataSource.filter = keyWord;

    this.bookingFiltered = this.booking.filter(trainee => {
      if (JSON.stringify(trainee).toLowerCase().includes(keyWord)) {
        return trainee;
      }
    });

    if (this.bookingFiltered.length) {
      this.selectBooking.selectBooking.setValue(this.bookingFiltered[0]);
      this.getSession(this.bookingFiltered[0].bookingKey);
    } else {
      this.selectBooking.selectBooking.setValue('no_result');
      this.selectSession.session.setValue('no_result');
    }
  }

  resetSearch(): void {
    this.valueInput = '';
    this.bookingFiltered = [];
    this.fsearch.keyword.reset();
    this.selectBooking.selectBooking.reset();
    this.seTable(this.booking);
    this.selectBooking.selectBooking.setValue(this.booking[0]);
    this.getSession(this.booking[0].bookingKey);
  }

  updateExpandedElement(element): void {
    this.expandedElement = this.expandedElement === element ? null : element;
  }

  getSession(bookingKey: any, html: boolean = false): void {
    const key = html ? bookingKey.value.bookingKey : bookingKey;
    this.bookingSessionService.getSessionsByBooking(key).subscribe({
      next: sessions => {
        this.sessions = sessions;
        this.selectSession.session.reset();
        this.selectSession.session?.setValue(this.sessions[0]);
      }
    });
  }

  setTab(tab: string): void {
    this.tab = tab;
  }

  getMargin(): string {
    const base = 32;

    const margin = {
      overview: base * 0 + '%',
      trainee: base * 1 + '%',
      club: base * 2 + '%',
    };

    return margin[this.tab];
  }

  exportPdfBill(book: BookingUser): void {
    book.isDownloading = true;
    this.pdfService.getPdfBookedSession(book.bookingKey).subscribe({
      next: blob => {
        const data = window.URL.createObjectURL(<any>blob.body);
        const anchor = document.createElement('a');
        const date = new Date();
        const time = date.getFullYear() + ('0' + (date.getMonth() + 1)).slice(-2) + ('0' + date.getDate()).slice(-2) + ('0' + date.getHours()).slice(-2) + ('0' + date.getMinutes()).slice(-2) + ('0' + date.getSeconds()).slice(-2);
        anchor.href = data;
        anchor.download = `NPHDF-${date.getFullYear()}-${book.bookingKey}-${time}.pdf`;
        anchor.click();

        setTimeout(() => {
          window.URL.revokeObjectURL(data);
        }, 100);

        book.isDownloading = false;
      }
    });
  }

  getTooltip(value: string): string {
    return this.tooltip.getTooltip(value);
  }

  setDate(date: Date): Date {
    const setDate = new Date(date);
    const newDate = new Date(setDate.setTime(setDate.getTime() - 60 * 60 * 1000));
    return newDate;
  }

  private seTable(booking: BookingUser[]): void {
    this.dataSource = new MatTableDataSource<BookingUser>(booking);
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
    this.length = booking.length;
  }

  private getBooking(): void {
    this.checkRoute !== -1 ? this.getBookingClub() : this.getBookingUser();
  }

  private getBookingClub(): void {
    const clubCode = this.route.snapshot.queryParams.clubCode ?
      this.route.snapshot.queryParams.clubCode :
      this.userConnected.club_code;
    this.bookingSessionService.getBookingByClub(clubCode).subscribe({
      next: bookings => {
        const bookingReverse = bookings.reverse();
        this.booking = [...bookingReverse];
        this.seTable(bookingReverse);
        this.offerPreview = this.bookedSessionsGroup[0];
      }
    });
  }

  private getBookingUser(): void {
    this.bookingSessionService.getBookingByUser(this.userKey).subscribe({
      next: bookings => {
        const bookingReverse = bookings.reverse();
        this.booking = [...bookingReverse];

        if (this.booking?.length) {
          this.selectBooking.selectBooking.setValue(this.booking[0]);
          this.getSession(this.booking[0].bookingKey);

        }
        this.seTable(bookingReverse);
        this.offerPreview = this.bookedSessionsGroup[0];
      }
    });
  }

  private initComponent(): void {
    this.userConnected = this.authService.getDecodedToken();
    this.userKey = this.userConnected.sub;
    this.checkRoute = this.router.url.search('/admin/');
    this.title = this.checkRoute !== -1 ? 'Liste des achats du club' : 'Liste de mes achats';
    this.displayedColumns = this.checkRoute !== -1 ?
      ['bookingReference', 'bookingRecordDate', 'lastName', 'firstName', 'email', 'bookedSessionCount', 'bookingAmount', 'pdf'] :
      ['pdf', 'bookingReference', 'bookingAmount', 'bookingRecordDate', 'bookedSessionCount'];
    this.pageSize = this.checkRoute !== -1 ? 10 : 5;

    this.getBooking();
  }


  get selectBooking() {
    return this.selectBookingMobileForm.controls;
  }

  get selectSession() {
    return this.selectSessionForm.controls;
  }

  get fsearch() {
    return this.searchForm.controls;

  }

  private initForm(): void {
    this.searchForm = this.formBuilder.group({
      keyword: ['']
    });

    this.selectBookingMobileForm = this.formBuilder.group({
      selectBooking: ['']
    });

    this.selectSessionForm = this.formBuilder.group({
      session: ['']
    });
  }

}
